module.exports = __webpack_public_path__ + "static/nozycowka-340ddbc95d50ea33f34a754996dc951f.jpg";